// removed by extract-text-webpack-plugin
module.exports = {"container":"_10lAnhze0bhlHTfn5P7lgH","form":"_3--T0PWgS3oBOs3_ImnMvY","field":"_35m5IcXj5jpzmQxcHjm_FY","icon":"_3JIUuoijWFmwcMGECSCrgp","title":"_3Tid49kJtu_9cy1NZsM5ns"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Preparation/Create/styles.css
// module id = 3265
// module chunks = 0